import { fetchPDV } from '@/api/business/pdv'
import { useQuery } from '@tanstack/react-query'

export const PDVKeys = {
    all: ['pdv'] as const,
    lists: () => [...PDVKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...PDVKeys.lists(), page, perPage, filters] as const,
    details: () => [...PDVKeys.all, 'detail'] as const,
    detail: (params: string) => [...PDVKeys.details(), params] as const,
}

export const usePDVQuery = (SK_REVENDA: number, enableStatus: boolean) => {
    return useQuery({
        enabled: enableStatus,
        queryFn:  () => fetchPDV(SK_REVENDA),
        queryKey: PDVKeys.lists(),
    })
}
